import { Col, Row } from "antd";
import { useIntl } from "react-intl";
import IdentificationField from "./IdentificationField";
import ResolutionsField from "./ResolutionsField";
import SortingField from "./SortingField";

const HeadToHeadParams = ({ handleSetConfiguration, configuration }) => {
  const { formatMessage } = useIntl();

  return (
    <Row>
      <Col span={8}>
        <SortingField
          fieldName={"sorts"}
          handleSetConfiguration={handleSetConfiguration}
          configuration={configuration}
          title={formatMessage({
            id: "sorting",
            defaultMessage: "Sorting",
          })}
          titleTooltip={formatMessage({
            id: "sorting",
            defaultMessage: "Sorting",
          })}
        />
      </Col>
      <Col span={8}>
        <Col>
          <ResolutionsField
            fieldName="headToHeadResolutions"
            handleSetConfiguration={handleSetConfiguration}
            configuration={configuration}
            title={formatMessage({
              id: "headToHeadResolutions",
              defaultMessage: "Head to head resolutions",
            })}
            titleTooltip={formatMessage({
              id: "headToHeadResolutions",
              defaultMessage: "Head to head resolutions",
            })}
          />
        </Col>
        <Col style={{ marginTop: 40 }}>
          <ResolutionsField
            fieldName="headToHeadResolutionsSubsequent"
            handleSetConfiguration={handleSetConfiguration}
            configuration={configuration}
            title={formatMessage({
              id: "headToHeadResolutionsSubsequent",
              defaultMessage: "Head to head resolutions (Subsequent)",
            })}
            titleTooltip={formatMessage({
              id: "headToHeadResolutionsSubsequent",
              defaultMessage: "Head to head resolutions (Subsequent)",
            })}
          />
        </Col>
      </Col>
      <Col span={8}>
        <Col>
          <IdentificationField
            title={formatMessage({
              id: "headToHeadIdentification",
              defaultMessage: "Head To Head identification",
            })}
            titleTooltip={formatMessage({
              id: "headToHeadIdentification",
              defaultMessage: "Head To Head identification",
            })}
            configuration={configuration}
            handleSetConfiguration={handleSetConfiguration}
            fieldName={"headToHeadIdentification"}
          />
        </Col>
        <Col style={{ marginTop: 40 }}>
          <IdentificationField
            title={formatMessage({
              id: "headToHeadIdentificationSubsequent",
              defaultMessage: "Head To Head identification (Subsequent)",
            })}
            titleTooltip={formatMessage({
              id: "headToHeadIdentificationSubsequent",
              defaultMessage: "Head To Head identification (Subsequent)",
            })}
            configuration={configuration}
            handleSetConfiguration={handleSetConfiguration}
            fieldName={"headToHeadIdentificationSubsequent"}
          />
        </Col>
      </Col>
    </Row>
  );
};

export default HeadToHeadParams;
